import Openable from 'utils/lib/openable';

class Drawer extends Openable {
  constructor(element: string | HTMLElement, useOverlay = true) {
    super(element, useOverlay);

    this.classes = {
      active: 'drawer--active',
    };
  }
}

export default (element: string | HTMLElement, useOverlay = true): Drawer => (
  new Drawer(element, useOverlay)
);
